__turbopack_context__.v({
  "className": "t-gI7W_className",
  "variable": "t-gI7W_variable",
});
